import React from 'react';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeExternalLinks from 'rehype-external-links';

import { InfoLabel } from '../../styled';

const Notice = ({ form }) => {
  return (
    <InfoWrapper>
      <InfoLabel alertLevel={form.alertLevel}>
        {form.alertLevel === 'LEVEL_INFO' && (
          <i
            className="fa fa-info-circle"
            style={{ marginRight: '10px', fontSize: '20px' }}
          />
        )}
        {form.alertLevel === 'LEVEL_WARNING' && (
          <i
            className="fa fa-exclamation-triangle"
            style={{ marginRight: '10px', fontSize: '20px' }}
          />
        )}
        <MarkdownWrapper>
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[[rehypeExternalLinks, { target: '_blank' }]]}
          >
            {form.alertString}
          </ReactMarkdown>
        </MarkdownWrapper>
      </InfoLabel>
    </InfoWrapper>
  );
};

const InfoWrapper = styled.div`
  margin-top: 24px;
  margin-bottom: 50px;
  // margin-left: 24px;
  max-width: var(--field-width);
`;

const MarkdownWrapper = styled.span`
  // white-space: pre-wrap;

  a {
    color: var(--green);
    text-decoration: underline;

    &:hover {
      color: var(--green);
    }

    &::after {
      font-family: 'Font Awesome 5 Free';
      content: '\f35d';
      font-weight: 900;
      font-size: 14px;
      margin-left: 4px;
      margin-right: 3px;
      text-decoration: none;
    }
  }
`;

export default Notice;
